let isCopying = false;

export function setIsCopying(value: boolean) {
  isCopying = value;
}

export function getIsCopying(): boolean {
  return isCopying;
}
